<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v50f5L/tc-custom/9781464207570.jpg?1731883537553" alt="This image is the cover for the book Return of the Raven Mocker, Alafair Tucker Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return of the Raven Mocker, Alafair Tucker Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Vividly rendered and psychologically astute, this somewhat transparent puzzler provides an unusually immersive perspective on familiar historical territory." —<i>Booklist</i></b></p><p><b>World War I is raging in Europe, but as the deadly influenza pandemic of 1918 sweeps like a wildfire through Boynton, Oklahoma, Alafair Tucker is fighting her own war.</b> Her daughter, Alice, and son-in-law, Walter Kelley, have both come down with the flu, and Alafair has moved into town to care for them after quarantining her young children at their sister's farm. Boynton as a whole isolates itself like an old English plague village, discouraging anyone from coming into town and the residents from traveling outside. A new doctor applies science to treating the stricken, but Alafair applies all she knows about hygiene, nutrition, and old and trusted country remedies. Unable to aid her sons and sons-in-law fighting overseas, this is danger she can combat.</p><p>One autumn afternoon, screams coming from next door alert Alafair that Alice's neighbor, Nola Thomason, and her son Lewis have suddenly and unexpectedly succumbed. Yet there is something about the way the pair died that causes Alafair to suspect their deaths were due to poison rather than to influenza. The epidemic is so overwhelming that it is many days before the only doctor left in town can confirm Alafair's suspicions; neither Nola nor Lewis died of the flu. The only witness to their deaths, twelve-year-old Dorothy Thomason, a special friend of Alafair's daughter, Sophronia, is so traumatized that she is rendered mute. Were Nola and her son murdered, and if so, why?</p><p>The usual motives for murder are greed, or jealousy, or hatred. Or could it be, as Alafair fears, that the Raven Mocker, the most dreaded of the Cherokee wizards or witches, the evil spirit who takes to the air in a fiery shape to rob the old, the sick, and the dying of their lives, is hunting victims and bringing misery to the innocent?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donis Casey
      </h2>
      
      <p class="authorDescription body article"><P>Donis Casey is the author of ten Alafair Tucker Mysteries. Donis has twice won the Arizona Book Award for her series, and been a finalist for the Willa Award and a seven-time finalist for the Oklahoma Book Award. Her first novel, The Old Buzzard Had It Coming, was named an Oklahoma Centennial Book in 2008. Donis is a former teacher, academic librarian, and entrepreneur. She lives in Tempe, Arizona.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3266ef3e